import * as React from 'react';
import clsx from 'clsx';

import * as styles from './RecommendationDesktopSkeleton.css';

export const RecommendationDesktopSkeleton: React.FC = () => (
  <div className={styles['container']}>
    <div className={clsx(styles['skeleton'], styles['image'])} />
    <div className={clsx(styles['skeleton'], styles['primary-line'])} />
    <div className={styles['skeleton']} />
  </div>
);
